import _ from 'underscore';
import Backbone from '@trello/backbone';

import type {
  RpcModelType,
  RpcUpdatePayload,
  RpcDeletePayload,
} from './rpc.types';

type TriggerableSocketRPCEvent =
  | 'connect'
  | 'connecting'
  | 'connect_failed'
  | 'ready'
  | 'reconnect'
  | 'reconnect_failed'
  | 'disconnect'
  | 'invalidModel'
  | 'subscription_invalid';
type ListenableSocketRPCEvent = TriggerableSocketRPCEvent | 'all';

type BackboneEvents = typeof Backbone.Events;
interface SocketRPCEvents extends BackboneEvents {
  on(type: 'updateModels', callback: (payload: RpcUpdatePayload) => void): this;
  on(type: 'deleteModels', callback: (payload: RpcDeletePayload) => void): this;
  on(
    type: 'invalidModel',
    callback: (typeName: RpcModelType, id: string) => void,
  ): this;
  on(
    type:
      | 'connect'
      | 'connecting'
      | 'connect_failed'
      | 'ready'
      | 'reconnect'
      | 'reconnect_failed'
      | 'disconnect'
      | 'invalidModel'
      | 'subscription_invalid',
    callback: () => void,
  ): this;
  off(
    type: 'updateModels' | null,
    callback: ((payload: RpcUpdatePayload) => void) | null,
  ): this;
  trigger(
    name: TriggerableSocketRPCEvent,
    data?: object | string,
    idModel?: string,
    tags?: string[],
  ): this;
  listenTo(
    context: this,
    name: ListenableSocketRPCEvent,
    callback: (name: TriggerableSocketRPCEvent, data?: object | string) => void,
  ): this;
}

export const socketRPCEvents: SocketRPCEvents = _.extend({}, Backbone.Events);
